import video from "../../assets/videos/home_featured_video.mp4";

const HomeVideo = () => {
  return (
    <section className="home_video_section">
      <div className="video_con">
        <video autoPlay muted loop className="video bg_image" src={video} />
      </div>
    </section>
  );
};

export default HomeVideo;
